import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { palette, transition, fontFamily } from '../../../styles/tokens';

interface SettingsSubPageProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export function SettingsSubPage({ title, description, children }: SettingsSubPageProps) {
  const navigate = useNavigate();

  return (
    <div>
      <button
        onClick={() => navigate('/settings')}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: 13,
          fontWeight: 500,
          color: palette.accent,
          fontFamily,
          padding: 0,
          marginBottom: 16,
          transition: `opacity ${transition.fast}`,
        }}
      >
        <ArrowLeft size={14} strokeWidth={2} />
        Back to settings
      </button>
      <div style={{
        fontSize: 18,
        fontWeight: 500,
        color: palette.g800,
        marginBottom: 4,
      }}>
        {title}
      </div>
      <div style={{
        fontSize: 13,
        color: palette.g500,
        marginBottom: 20,
        lineHeight: 1.4,
      }}>
        {description}
      </div>
      {children}
    </div>
  );
}
